import { createSlice } from "@reduxjs/toolkit";

import { fetchDashboardStats } from "@/modules/hrPortal/store/dashboardThunk";

import { HRDashboardData } from "../types";

// Backward-compatible re-exports: DepartmentHiring, RecentVoiceCall, and
// HRDashboardData used to be defined directly in this file. Re-exporting
// them (now sourced from the shared types folder, where RecentVoiceCall was
// merged with the near-identical VoiceCallLog type) keeps any other file
// that imports these names from this path working unchanged.
export type { DepartmentHiring, VoiceCallLog as RecentVoiceCall, HRDashboardData } from "../types";

interface HRDashboardState {
  data: HRDashboardData | null;
  loading: boolean;
  error: string | null;
}

const initialState: HRDashboardState = {
  data: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "hrDashboard",

  initialState,

  reducers: {
    clearDashboardStats: (state) => {
      state.data = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })

      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch HR dashboard statistics";
      });
  },
});

export const { clearDashboardStats } = dashboardSlice.actions;

export default dashboardSlice.reducer;